import { nextDrawerNodeIdAtom } from "@features/builder/graph/graphAtoms"
import { AppNode, EdgeData } from "@features/builder/graph/types"
import { Edge, useReactFlow, useStoreApi } from "@xyflow/react"
import { useSetAtom } from "jotai"

const DEFAULT_FIT_VIEW = { duration: 0, maxZoom: 2.5 } as const

export function useGoToNode() {
  const reactFlow = useReactFlow<AppNode, Edge<EdgeData>>()
  const setNextDrawerNodeId = useSetAtom(nextDrawerNodeIdAtom)
  const store = useStoreApi<AppNode>()
  const { addSelectedNodes } = store.getState()

  return (id: string) => {
    reactFlow.fitView({ nodes: [{ id }], ...DEFAULT_FIT_VIEW })
    addSelectedNodes([id])
    setNextDrawerNodeId(id)
  }
}
